import React, { useEffect, useState } from 'react';
import { Card } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { useSelector, history } from 'umi';
import { getDataRecentlyViewed } from '@/pages/home/services/home';
import { RecentlyViewedType } from '@/pages/home/types/home';
import { getEntityTypeIcon } from '@/pages/home/pages/home/Explore/_config/common';
// import { showErrorMessagetip } from '@/pages/home/components/ErrorMessageTip/ErrorMessageTip';
import { useIntl } from 'umi';
import Abnormal from '@/pages/home/components/Abnormal';
import GameImage from '@/pages/home/components/GameImage';
import {
  getDashboardGamePath,
  getIntelligenceGamePath,
  getOpinionGamePath,
} from '@/pages/home/utils/utils';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';

export default function RecentlyViewed(props: any) {
  const { formatMessage } = useIntl(); // 中英切换方法
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [recentData, setRecentData] = useState<RecentlyViewedType[]>([]);

  const { userInfo } = useSelector((state: any) => {
    const { userInfo } = state.home;
    return {
      userInfo,
    };
  });

  useEffect(() => {
    if (userInfo?.openid) {
      getData(userInfo?.openid);
    }
  }, [userInfo?.openid]);

  const getData = async (openid: string) => {
    setLoading(true);
    try {
      const res = await getDataRecentlyViewed({ open_id: openid });
      setRecentData(res);
      setError(false);
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const getGamePath = (e: RecentlyViewedType) => {
    let path = '';
    if (e?.module_name === 'Opinions') {
      path = getOpinionGamePath(e?.unified_edition_id, e?.entity_type, e?.id_type, 'socialMedia');
    } else if (e?.module_name === 'Intelligence') {
      if (e?.entity_type === 'company') {
        path = getIntelligenceGamePath(e?.unified_edition_id, e?.entity_type, 'Summary');
      } else {
        path = getIntelligenceGamePath(e?.unified_edition_id, e?.entity_type, 'overview');
      }
    } else if (e?.module_name === 'Dashboard') {
      path = getDashboardGamePath(e?.unified_edition_id);
    }
    return path;
  };

  const onClickGame = (e: RecentlyViewedType) => {
    const gamePath = getGamePath(e);
    history.push(gamePath);
    // TODO 规范：General Information Tips
    // showErrorMessagetip({
    //   errorCode: '',//err.code,
    //   content: formatMessage({ id: 'dbh_recentlyviewed_tip' }), //Coming soon
    //   duration: 30000,
    //   isClose: true,
    //   type: 'warning',
    // });
    // return;
  };

  return (
    <Card className="recent-card">
      <Card.Body
        title={
          <div className="home-table-title"> {formatMessage({ id: 'dbh_recentlyviewed' })}</div>
        }
      >
        <Abnormal
          isLoading={loading}
          isError={error}
          isNoData={!recentData?.length}
          component={
            <>
              {recentData?.map((e) => {
                const flag = e?.module_name === '' || e?.entity_name === '';
                if (flag) {
                  return <React.Fragment key={e.unified_edition_id}></React.Fragment>;
                }

                return (
                  <ARightClickToJump
                    href={getGamePath(e)}
                    // style={{ display: 'inline' }}
                  >
                    <div
                      className="recently-flex"
                      key={e?.unified_edition_id}
                      onClick={() => onClickGame(e)}
                    >
                      <div className="recently-flex-context">
                        <GameImage src={e?.cover} className="recently-flex-img" />
                        <div className="recently-flex-text">
                          <div className="recently-flex-name">{e?.entity_name}</div>
                          <div className="recently-flex-desc">
                            {formatMessage({
                              id: `dbh_recently_${e?.module_name?.toLocaleLowerCase()}`,
                              defaultMessage: e?.module_name,
                            })}
                          </div>
                        </div>
                      </div>
                      <SvgIcon
                        type={getEntityTypeIcon(e?.entity_type)}
                        className="recently-flex-icon"
                      />
                    </div>
                  </ARightClickToJump>
                );
              })}
            </>
          }
        />
      </Card.Body>
    </Card>
  );
}
